module.exports = __webpack_public_path__ + "static/share-thumbnail-466432a42770736a0e32617903ae8c4d.jpg";